/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { useQuery } from '@apollo/client';

import loadable from '@loadable/component';
import * as app from '../../../../state/ducks/App';
import { GRAPHQL_ENV } from '../../../gql';
import findContent from '../../../gql/queries/findContent';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import PassportEnrollmentPage from './PassportPageV2/PassportEnrollmentPage';

const PassportBlock = loadable(() => import(/* webpackChunkName: "PassportBlock" */ './PassportBlock'));

const brandSelectors = app.ducks.brand.selectors;
const PassportPage = ({
    brand, featureFlags,
}) => {
    const PASSPORT_PAGE_QUERY = findContent({
        brand: brand.domain,
        locale: 'en-us',
        contentType: 'passport_enrolment_page',
    });

    const cartIconLabel = featureFlags['cart-icon-label']?.label || 'Cart';

    const { error, data } = useQuery(PASSPORT_PAGE_QUERY);
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: PASSPORT_PAGE_QUERY,
            component: 'PassportPage.js',
            message: `Error loading data from Graphql ${error}`,
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }
    if (!data) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: PASSPORT_PAGE_QUERY,
            component: 'PassportPage.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
        return null;
    }
    if (data?.findContent?.content?.entries?.length > 0) {
        const content = data.findContent.content.entries[0];

        return (
            <>
                {featureFlags['is-passport-enrollment-pg-v2-enabled']
                    ? (
                        <>
                            <PassportEnrollmentPage data={content} cartIconLabel={cartIconLabel} />
                        </>
                    )
                    : <PassportBlock data={content} />}
            </>
        );
    }
    return null;
};

PassportPage.propTypes = {
    brand: object.isRequired,
    featureFlags: object,
};

PassportPage.defaultProps = {
    featureFlags: {},
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
    featureFlags: getFeatureFlags(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);

export default enhance(PassportPage);
